var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from "@mui/material";
var ConfirmDialog = function (_a) {
    var open = _a.open, title = _a.title, message = _a.message, _b = _a.cancelLabel, cancelLabel = _b === void 0 ? "Cancelar" : _b, _c = _a.confirmLabel, confirmLabel = _c === void 0 ? "Confirmar" : _c, _d = _a.confirmColor, confirmColor = _d === void 0 ? "primary" : _d, onCancel = _a.onCancel, onConfirm = _a.onConfirm;
    return (_jsxs(Dialog, __assign({ open: open, transitionDuration: 0 }, { children: [title && _jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: message }) }), _jsxs(DialogActions, __assign({ sx: { px: 3, pb: 3, gap: 1 } }, { children: [_jsx(Button, __assign({ variant: "contained", onClick: onCancel }, { children: cancelLabel })), _jsx(Button, __assign({ variant: "contained", color: confirmColor, onClick: onConfirm, sx: {
                            bgcolor: "".concat(confirmColor, ".main"),
                            color: "".concat(confirmColor, ".contrastText"),
                            "&:hover": { bgcolor: "".concat(confirmColor, ".dark") },
                        } }, { children: confirmLabel }))] }))] })));
};
export default ConfirmDialog;
